import { render } from "./UnitDetailsPage.vue?vue&type=template&id=7ab864c0"
import script from "./UnitDetailsPage.vue?vue&type=script&lang=js"
export * from "./UnitDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__